import { ColumnDensity } from '@common/types';
import TableRowsIcon from '@mui/icons-material/TableRows';
import { Button, Typography } from '@mui/material';
import { Dropdown, DropdownMenuItem } from 'components/Dropdown';

type ColumnDensityFilterProps = {
  handleDensityChange: (density: ColumnDensity) => void;
  selectedValue?: ColumnDensity;
  hideText?: boolean;
};

export const ColumnDensityFilter = ({
  handleDensityChange,
  selectedValue,
  hideText,
}: ColumnDensityFilterProps) => {
  const dropdownMenu: DropdownMenuItem[] = [
    {
      iconName: 'none',
      label: 'Comfortable',
      onClick: () => handleDensityChange('comfortable'),
      selected: selectedValue === 'comfortable',
    },
    {
      iconName: 'none',
      label: 'Compact',
      onClick: () => handleDensityChange('compact'),
      selected: selectedValue === 'compact',
    },
    {
      iconName: 'none',
      label: 'Dense',
      onClick: () => handleDensityChange('dense'),
      selected: selectedValue === 'dense',
    },
  ];

  return (
    <Dropdown
      menuList={dropdownMenu}
      buttonComponent={
        <Button
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            fontSize: '15px',
            height: '100%',
            fontWeight: 'medium',
          }}
          color='primary'
          variant='text'
        >
          <TableRowsIcon />
          <Typography
            sx={{
              display: {
                lg: 'initial',
                md: hideText ? 'none' : 'initial',
                sm: 'none',
              },
              fontWeight: 500,
            }}
          >
            DENSITY
          </Typography>
        </Button>
      }
    />
  );
};
